import React from "react";
import ReactDOM from "react-dom/client";
import ConfirmationModal from "./ConfirmationModal";

class ConfirmationService {
  private container: HTMLDivElement | null = null;
  private root: ReactDOM.Root | null = null;

  private createContainer(): ReactDOM.Root {
    if (!this.container) {
      this.container = document.createElement("div");
      this.container.id = "confirmation-modal-root";
      document.body.appendChild(this.container);
      this.root = ReactDOM.createRoot(this.container);
    }

    return this.root!;
  }

  private removeContainer(): void {
    if (!this.container || !this.root) return;

    this.root.unmount();
    this.container.remove();
    this.container = null;
    this.root = null;
  }

  async show(
    title: string = "Are you sure?",
    text: string = "This action cannot be undone.",
    confirmButtonText: string = "Confirm",
    cancelButtonText: string = "Cancel",
  ): Promise<boolean> {
    return new Promise((resolve) => {
      const root = this.createContainer();
      let hasResolved = false;

      const finish = (result: boolean) => {
        if (hasResolved) return;

        hasResolved = true;
        this.removeContainer();
        resolve(result);
      };

      root.render(
        <ConfirmationModal
          isOpen
          onClose={() => finish(false)}
          onConfirm={() => finish(true)}
          title={title}
          text={text}
          confirmButtonText={confirmButtonText}
          cancelButtonText={cancelButtonText}
        />,
      );
    });
  }
}

export const confirmationService = new ConfirmationService();